import { Text } from "@/design-system";
import { t } from "@/context/language";
import type { SolutionChat } from "../constants/solutionChats";

type ChatPreviewCardProps = {
  chat: SolutionChat;
};

export function ChatPreviewCard({ chat }: ChatPreviewCardProps) {
  return (
    <div className="rounded-ds-xl bg-ds-paper-marketing shadow-ds-raised flex gap-3 p-3 sm:gap-4 sm:p-4">
      {/* Etiqueta vertical da loja: a mensagem chega no mesmo chat, mas cada
          cliente vem de uma loja diferente. */}
      <span className="rounded-ds-md bg-ds-brand-600 text-ds-on-solid font-ds-sans text-ds-caption flex shrink-0 rotate-180 items-center justify-center px-1.5 py-3 tracking-wide whitespace-nowrap uppercase [writing-mode:vertical-rl]">
        {t.solutions.chatsCard.customer}&nbsp;
        <span className="font-semibold">
          {t.solutions.chatsCard.store} {chat.store}
        </span>
      </span>
      <img
        src={chat.avatar}
        alt=""
        width={44}
        height={44}
        loading="lazy"
        decoding="async"
        className="bg-ds-ink-100 hidden size-11 shrink-0 rounded-full object-cover sm:block"
      />
      {/* O corte fica no span de dentro: com o padding no mesmo elemento, a
          linha cortada aparecia pela metade no respiro de baixo. */}
      <span className="rounded-ds-lg bg-ds-warning-50 min-w-0 flex-1 self-start px-3 py-2">
        <Text as="span" tone="warning" className="line-clamp-4 sm:line-clamp-3">
          {chat.message}
        </Text>
      </span>
    </div>
  );
}
